export type RemissionAssetUi = {
  asset?: RemissionAsset;
  cancelDisabled?: boolean;
  saveDisabled?: boolean;
};

export type RemissionAsset =
  | { kind: 'pdfSavedAsset'; url: string }
  | { kind: 'imageSavedAsset'; url: string }
  | { kind: 'imagePendingToSaveAsset'; data: string }
  | { kind: 'pdfPendingToSaveAsset' };

export const initialState: RemissionAssetUi = {
  cancelDisabled: true,
  saveDisabled: true,
};
